export default __webpack_public_path__ + "static/media/file_loading.9047434a.svg";